import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
  align?: 'left' | 'center' | 'right';
  light?: boolean;
  decorated?: boolean;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  centered = true,
  align,
  light = false,
  decorated = true,
}) => {
  // align prop takes precedence over centered
  const textAlign = align 
    ? align === 'center' 
    : centered;
  
  return (
    <div className={cn('mb-12 md:mb-16', textAlign && 'text-center', align === 'left' && 'text-left', align === 'right' && 'text-right')}>
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className={cn(
          'text-3xl md:text-4xl lg:text-5xl font-heading font-bold mb-4',
          light ? 'text-primary-foreground' : 'text-foreground'
        )}
      >
        {title}
      </motion.h2>
      
      {decorated && (
        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className={cn(
          'h-1 w-24 bg-secondary rounded-full mb-6',
            textAlign && 'mx-auto',
            align === 'left' && 'mx-0',
            align === 'right' && 'ml-auto mr-0'
          )}
        />
      )}
      
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className={cn(
          'text-lg md:text-xl max-w-3xl font-body',
          light ? 'text-primary-foreground/80' : 'text-text-light',
          textAlign && 'mx-auto',
          align === 'left' && 'mx-0',
          align === 'right' && 'ml-auto mr-0'
        )}
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  );
};

export default SectionHeader;
